module.exports = __webpack_public_path__ + "img/l-banner-overlay.d6fa05c0.png";